import { render, staticRenderFns } from "./CommercialImports.vue?vue&type=template&id=18cc5a05&"
import script from "./CommercialImports.vue?vue&type=script&lang=js&"
export * from "./CommercialImports.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports